import { AlertDescriptionMultiAnalysisProps } from "../../@types";
import AlertDescriptionSampleLink from "../AlertDescriptionSampleLink";

const AlertDescriptionIntegration = ({
  integrationName,
  type,
  data,
  linksReloadDocument,
  onLinkClick
}: AlertDescriptionMultiAnalysisProps) => {
  const typeString = type.split("_").pop();
  return (
    <>
      {integrationName} Analysis{" "}
      <AlertDescriptionSampleLink
        data={data}
        linksReloadDocument={linksReloadDocument}
        onLinkClick={onLinkClick}
      />{" "}
      has {typeString}.
    </>
  );
};

export default AlertDescriptionIntegration;
